"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASHBOARD_EVENTS = void 0;
exports.DASHBOARD_EVENTS = {
    DASHBOARDS_DATA_UPDATED: 'dashboards data updated',
    WIDGET_DATA_FETCHED: 'widget data fetched'
};
//# sourceMappingURL=dashboard.consts.js.map